import { FeatureFlags } from 'application/constants/env-variables';
import styles from './Header.module.scss';
import { UserCircle } from './UserCircle/UserCircle.tsx';
import { AppLink } from 'components/uikit/buttons/AppLink';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { Links } from 'application/constants/links.ts';

export const ErrorPageHeader: React.FC = () => {
  const i18n = useScopedTranslation('Component.Header');

  return (
    <header className={styles.header}>
      <UserCircle />
      <div className={styles.right}>
        {FeatureFlags.templateMergingPageEnabled() && (
          <AppLink
            className={styles.link}
            to={Links.Authorized.TemplatesMerging.link()}
          >
            <TextButton
              testId="to-templates-merging"
              className={styles.button}
              title={'Template Merging'}
              color={TextButtonColor.Primary}
            />
          </AppLink>
        )}

        <AppLink className={styles.link} to={Links.Authorized.Templates.link()}>
          <TextButton
            testId="to-templates"
            className={styles.button}
            title={i18n.t('templates')}
            color={TextButtonColor.Primary}
          />
        </AppLink>
      </div>
    </header>
  );
};
